export default __webpack_public_path__ + "0d0b78b03937503e4a05518ee771f88b.gif";